import Ajax from 'js/utils/ajax/ajax';

import { DashboardDataInterval } from '../../../interfaces';

export const getDashboardPackageData = (interval: DashboardDataInterval) =>
  Ajax.get(`/dashboard/v1/packages/${interval}`);
